import React, { useState } from 'react';
import '../../entrydoor.css';

const SecurityWindowFilm = ({ value, onChange, label = 'Security Window Film' }) => {
    const [selectedSecurityWindowFilm, setSelectedSecurityWindowFilm] = useState(value || "");

    const handleSecurityWindowFilmChange = (e) => {
        setSelectedSecurityWindowFilm(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="SecurityWindowFilm">{label}</label>
            <select
                id="SecurityWindowFilm"
                value={selectedSecurityWindowFilm}
                onChange={handleSecurityWindowFilmChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedSecurityWindowFilm === "Yes" ? "Yes ✔" : "Yes"}</option>
                <option value="No">{selectedSecurityWindowFilm === "No" ? "No ✔" : "No"}</option>
            </select>
        </div>
    );
};

export default SecurityWindowFilm;
